import React from 'react';
import {Text} from '@tenancy.nz/design-system';

const nl2br = str =>
  String(str)
    .split('\n')
    .filter(line => line !== '\r' && !!line.trim())
    .map(line => <Text paragraph>{line}</Text>);

export default nl2br;
